import get from 'lodash/get';
import PropTypes from 'prop-types';
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import {truncate} from '../../helpers/stringUtils';
import {formatDateOfBirth, formatLastSeen, getAge} from '../../helpers/patients';
import EditPatientStatus from './EditPatientStatus';
import EditPatientMemoDialog from './EditPatientMemoDialog';
import EditPatientLeadDialog from './EditPatientLeadDialog';
import {EditIcon} from "../../styles/icons";

const PatientTableRow = props => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const {data: p} = props;
  return (
    <TableRow
      key={p.id}
    >
      <TableCell sx={{ 'input': { fontSize: '0.65625rem !important' } }}>
        {
          isOpen === 'note'
              ? <EditPatientMemoDialog
                  patient={p}
                  isOpen={!!isOpen}
                  onClose={() => setIsOpen(false)}
                  onSuccess={() => props.reload()}
              />
              : null
        }
        {
          isOpen === 'referralDetails'
              ? <EditPatientLeadDialog
                  patient={p}
                  isOpen={!!isOpen}
                  onClose={() => setIsOpen(false)}
                  onSuccess={() => props.reload()}
              />
              : null
        }
        <EditPatientStatus patient={p}/>
      </TableCell>
      <TableCell>
        <Button type='text' onClick={() => navigate(`/providers/patients/view/${p.id}`)} sx={{ minHeight: 0, minWidth: 0, padding: 0 }}>
          <Typography variant='small500Inter' sx={{textAlign: 'left'}}>
            {p.user.first_name} {p.user.last_name}
          </Typography>
        </Button>
      </TableCell>
      <TableCell>
        {!p.date_birth ? '-' : `${formatDateOfBirth(p)} (${getAge(p)})`}
      </TableCell>
      <TableCell>
        {formatLastSeen(p)}
      </TableCell>
      <TableCell sx={{...buttonStyle}}>
        <Stack
          direction='row'
          alignItems='center'
        >
          <Tooltip title='Edit Lead'>
            <IconButton color='primary' variant='outlined' onClick={() => setIsOpen('referralDetails')}>
              <EditIcon style={{fontSize: '0.9rem'}} fill={'var(--primary)'}/>
            </IconButton>
          </Tooltip>
          <Typography variant='small500'>
            {truncate(p.referral_details, {length: 15}) || '-'}
          </Typography>
        </Stack>
      </TableCell>
      <TableCell sx={{maxWidth: '200px', ...buttonStyle}}>
        <Stack
          direction='row'
          alignItems='center'
        >
          <Tooltip title='Edit Memo'>
            <IconButton color='primary' onClick={() => setIsOpen('note')}>
              <EditIcon style={{fontSize: '0.9rem'}} fill={'var(--primary)'}/>
            </IconButton>
          </Tooltip>
          <Typography 
            variant='small500' 
            style={{
              textOverflow: 'ellipsis', 
              overflow: 'hidden', 
              whiteSpace: 'nowrap',
              maxWidth: '500px',
              minWidth: '150px'
            }}
          >
            {get(p, 'patient_status.note') || '-'}
          </Typography>
        </Stack>
      </TableCell>
      <TableCell>
        {p?.cases?.length 
          ? p.cases.map((c, i) => (
            <Button 
              key={i} 
              type='text' 
              size='small'
              onClick={() => navigate(`/providers/sessions?case_id=${c.id}`)}
            >
              <Typography variant='small500'>
                {c.name}
              </Typography>
            </Button>
          ))
          : null
        }
      </TableCell>
      <TableCell sx={{...buttonStyle}}>
        <Stack direction='row' spacing={2} justifyContent="center">
          {props.buttons}
        </Stack>
      </TableCell>
    </TableRow>
  );
};

const buttonStyle = {
  'button': { padding: '2px !important' }
}

PatientTableRow.propTypes = {
  data: PropTypes.object,
  buttons: PropTypes.arrayOf(PropTypes.element),
  reload: PropTypes.func,
};

export default PatientTableRow;
